import {
  AlertTriangle,
  Brain,
  ClipboardList,
  FileText,
  HeartPulse,
  Sparkles,
  TrendingDown,
  TrendingUp,
  Users,
  type LucideIcon,
} from "lucide-react";

/**
 * Allow-list mapping the `icon` string on a server `InsightRecord` to a Lucide
 * component. Server insights store icons by name (they can't serialise React
 * components); generators must use a name from this list. Unknown names fall
 * back to {@link Sparkles}.
 */
const INSIGHT_ICONS: Record<string, LucideIcon> = {
  AlertTriangle,
  Brain,
  ClipboardList,
  FileText,
  HeartPulse,
  Sparkles,
  TrendingDown,
  TrendingUp,
  Users,
};

export function resolveInsightIcon(name: string): LucideIcon {
  return INSIGHT_ICONS[name] ?? Sparkles;
}
